import React from "react";
import ReactDom from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import reduxThunk from "redux-thunk";
import TagManager from "react-gtm-module";

import App from "./components/App";
import reducers from "./reducers";

import * as serviceWorker from "./serviceWorker";

const store = createStore(reducers, {}, applyMiddleware(reduxThunk));

const tagManagerArgs = {
  gtmId: "GTM-NDBQSZ3",
  dataLayer: {
    userId: "001",
    userProject: "golf"
  }
};

TagManager.initialize(tagManagerArgs);

ReactDom.render(
  <Provider store={store}>
    {" "}
    <App />{" "}
  </Provider>,
  document.querySelector("#root")
);
serviceWorker.register();
